/* Creazione del componente per visualizzare nel menu laterale orario e data*/
import 'date-fns';
import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import itLocale from "date-fns/locale/it";
import frLocale from "date-fns/locale/fr";
import enLocale from 'date-fns/locale/en-US'
import { KeyboardDateTimePicker } from "@material-ui/pickers";
import './DataOra.css'
import { useTranslation } from 'react-i18next';

export default function DataOra(props) {
  const inProps = props
  const [selectedDate, setSelectedDate] = React.useState(inProps.dataOra);
  const handleDateChange = (date) => {
    setSelectedDate(date);
    inProps.callback(date);

    
  };
  //funzione per far tornare l'orario in base alla lingua scelta
  const {t} = useTranslation();
  const switchLocale = () => {
    try {
      switch (t('it')) {
        case 'en':
    
            return enLocale
        case 'it':
    
            return itLocale
            case 'fr':
    
              return frLocale
        default:
            return enLocale;
        }
    } catch (error) {
      return itLocale
    }


  }

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={switchLocale()}>
       <div>
          <KeyboardDateTimePicker
            variant="inline"
            ampm={false}
            label=""
            value={selectedDate}
            onChange={handleDateChange}
            onError={console.log}
            format="dd/MM/yyyy HH:mm"
          />
        </div>

    </MuiPickersUtilsProvider>
  );
}